import { render, staticRenderFns } from "./table.module.vue?vue&type=template&id=e59fb454&scoped=true"
import script from "./table.module.vue?vue&type=script&lang=js"
export * from "./table.module.vue?vue&type=script&lang=js"
import style0 from "./table.module.vue?vue&type=style&index=0&id=e59fb454&prod&lang=scss&scoped=true"
import style1 from "./table.module.vue?vue&type=style&index=1&id=e59fb454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59fb454",
  null
  
)

export default component.exports